import * as actions from '../redux/actions';

import BookingSuccess from '../BookingSuccess/BookingSuccess';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const BookingConfirmation = ({ status, pnrNumber, loading, ticketDetails, t, history }) => {
  if (status == 'success') {
    return (
      <BookingSuccess
        pnrNumber={pnrNumber}
        loading={loading}
        ticketDetails={ticketDetails}
        history={history}
        success={true}
        t={t}
        appType={localStorage.getItem('appType')}
      />
    );
  }
  return <BookingSuccess success={false} />;
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    pbPaymentDetails: state.pbPaymentDetails,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookingConfirmation);



// WEBPACK FOOTER //
// ./src/features/Pasajebus/PasajebusPaymentDetails/BookingConfirmation/BookingConfirmation.js